import { Box, Tooltip, Avatar, Autocomplete, TextField } from '@mui/material';
import {
  ArrowDropDown as ArrowDropDownIcon,
  ArrowDropUp as ArrowDropUpIcon,
} from '@mui/icons-material';
import { autoCompleteStyles, avatarStyles, getAutoCompleteNameStyles } from './styles';

interface AssigneeAvatarContentProps {
  searchTerm: string;
  assigneeName?: string;
  profileImage?: string;
  fallbackProfileImage: string;
  open: boolean;
  handleSearchFieldClick: (e: React.MouseEvent<HTMLDivElement>) => void;
  setSearchTerm: (value: string) => void;
  assingeFieldColor?: string;
}

export const AssigneeDropdown = ({
  searchTerm,
  assigneeName,
  profileImage,
  fallbackProfileImage,
  open,
  handleSearchFieldClick,
  setSearchTerm,
  assingeFieldColor,
}: AssigneeAvatarContentProps) => {
  return (
    <Tooltip placement="right" title={searchTerm || assigneeName || 'Unassigned'} arrow>
      <Box
        sx={{ display: 'flex', alignItems: 'center', width: '100%', cursor: 'text' }}
        onClick={handleSearchFieldClick}
      >
        <Avatar
          sx={{ ...avatarStyles, marginRight: '8px' }}
          alt="Assignee avatar"
          src={profileImage || fallbackProfileImage}
        />
        <Autocomplete
          freeSolo
          disableClearable
          options={[]}
          inputValue={searchTerm}
          onInputChange={(_, newValue) => setSearchTerm(newValue)}
          renderInput={(params) => (
            <TextField
              {...params}
              variant="standard"
              placeholder={assigneeName || 'Unassigned'}
              sx={getAutoCompleteNameStyles(assingeFieldColor)}
              slotProps={{
                input: {
                  ...params.InputProps,
                  disableUnderline: true,
                },
              }}
            />
          )}
          onKeyDown={(e) => {
            if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
              e.stopPropagation();
            }
          }}
          onClick={(e) => {
            e.stopPropagation();
          }}
          openOnFocus={false}
          open={false}
          sx={autoCompleteStyles}
        />
        {open ? (
          <ArrowDropUpIcon sx={{ color: assingeFieldColor }} />
        ) : (
          <ArrowDropDownIcon sx={{ color: assingeFieldColor }} />
        )}
      </Box>
    </Tooltip>
  );
};
